import { type SelectItem } from "@mantine/core";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

interface IL10typeItem {
  lbid: string;
  lbname: string;
}

export const getSaveParams = (data: any, rid?: string) => ({
  ...data,
  data: {
    ...data.data,
    dates: Number(data.data.dates),
    type: Number(data.data.type),
    status: Number(data.data.status),
    stampPlacement: data.data.stampPlacement || "pdfAndScreen",
  },
  rid,
});

export const mapReportForm = (data: any, rid?: string) => {
  const sections: Record<string, SelectItem[]> = {};
  const mappedLbs: SelectItem[] = [];

  data.data.reports.lbs.forEach((lb: any) => {
    mappedLbs.push({
      value: lb.lbid,
      label: lb.lbname,
      crewListReport: lb.crewListReport ?? false,
    });
    if (lb.sections)
      sections[lb.lbid] = [
        { value: "*", label: "All Sections" },
        ...lb.sections.map((part: any) => ({
          value: part.lbid,
          label: part.lbname,
        })),
      ];
  });

  mappedLbs.unshift({ value: "*", label: "All logbooks" });
  const olbs = data.data.olbs
    ? Object.values(data.data.olbs).map((lb: any) => ({
        value: lb.lbid,
        label: lb.lbname,
      }))
    : [];

  const mappedL10 = data?.data?.l10type?.map((lb: IL10typeItem) => ({
    value: lb.lbid,
    label: lb.lbname,
  }));

  let resetValues = null;
  if (rid) {
    let report = data.data.reports.list.find(
      (r: { rid: string }) => r.rid === rid,
    );
    report = { ...report, data: JSON.parse(report.data) };
    const last10type = Number(report.data.type) === 1;
    const wasteDtype = Number(report.data.type) === 3;
    resetValues = {
      name: report.name,
      desc: report.descr,
      data: {
        crewStatus: report.data.crewStatus ?? "*",
        selectedUsers: report.data.selectedUsers ?? [],
        dates: !last10type && String(report.data.dates),
        logbook: !last10type && !wasteDtype && report.data.logbook,
        section: !last10type && !wasteDtype && report.data.section,
        type: String(report.data.type),
        status: !last10type && !wasteDtype && String(report.data.status),
        lb10: last10type && !wasteDtype ? report.data.lb10 : "",
        start:
          !last10type && report.data.start ? new Date(report.data.start) : null,
        end: !last10type && report.data.end ? new Date(report.data.end) : null,
        stamp: report.data.stamp || "",
        stampPlacement: report.data.stampPlacement || "pdfAndScreen",
      },
    };
  }

  return { l10: mappedL10, lbs: mappedLbs, sections, resetValues, olbs };
};
